import React from 'react';

interface CompanyBrandColorsProps {
  formData: any;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
  setFormData: (updater: (prev: any) => any) => void;
}

export const CompanyBrandColors: React.FC<CompanyBrandColorsProps> = ({ formData, handleChange, setFormData }) => {
  return (
    <div className="form-section">
      <h3>Brand Colors</h3>
      <p style={{ fontSize: '0.9em', color: 'var(--color-neutral-graphite)', marginBottom: '20px' }}>
        These colors will be used in invoices, emails, and other documents to match your company branding.
      </p>
      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="brand_color_primary">Primary Brand Color</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input
              type="color"
              id="brand_color_primary"
              name="brand_color_primary"
              value={formData.brand_color_primary}
              onChange={handleChange}
              style={{
                width: '50px',
                height: '40px',
                border: '1px solid var(--color-neutral-light-gray)',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            />
            <input
              type="text"
              value={formData.brand_color_primary}
              onChange={(e) => setFormData(prev => ({ ...prev, brand_color_primary: e.target.value }))}
              className="form-control"
              placeholder="#4176ba"
              pattern="^#[0-9A-Fa-f]{6}$"
              style={{ flex: 1 }}
            />
          </div>
          <p style={{ fontSize: '0.8em', color: 'var(--color-neutral-graphite)', marginTop: '5px' }}>
            Used for headers, buttons, and primary elements
          </p>
        </div>
        <div className="form-group">
          <label htmlFor="brand_color_secondary">Secondary Brand Color</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <input
              type="color"
              id="brand_color_secondary"
              name="brand_color_secondary"
              value={formData.brand_color_secondary}
              onChange={handleChange}
              style={{
                width: '50px',
                height: '40px',
                border: '1px solid var(--color-neutral-light-gray)',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            />
            <input
              type="text"
              value={formData.brand_color_secondary}
              onChange={(e) => setFormData(prev => ({ ...prev, brand_color_secondary: e.target.value }))}
              className="form-control"
              placeholder="#349b94"
              pattern="^#[0-9A-Fa-f]{6}$"
              style={{ flex: 1 }}
            />
          </div>
          <p style={{ fontSize: '0.8em', color: 'var(--color-neutral-graphite)', marginTop: '5px' }}>
            Used for accents, highlights, and secondary elements
          </p>
        </div>
      </div>
      <div style={{
        marginTop: '20px', 
        padding: '15px', 
        backgroundColor: '#f8f9fa', 
        borderRadius: '6px',
        border: '1px solid var(--color-neutral-light-gray)'
      }}>
        <h4 style={{ margin: '0 0 10px 0', fontSize: '14px', fontWeight: '600' }}>Color Preview</h4>
        <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
          <div style={{
            background: `linear-gradient(135deg, ${formData.brand_color_primary} 0%, ${formData.brand_color_secondary} 100%)`,
            width: '100px',
            height: '40px',
            borderRadius: '4px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontSize: '12px',
            fontWeight: '600'
          }}>
            Email Header
          </div>
          <div style={{
            border: `2px solid ${formData.brand_color_primary}`,
            padding: '8px 16px',
            borderRadius: '4px',
            color: formData.brand_color_primary,
            fontSize: '12px',
            fontWeight: '500'
          }}>
            Invoice Details
          </div>
          <div style={{
            backgroundColor: formData.brand_color_secondary + '20',
            border: `1px solid ${formData.brand_color_secondary}`,
            borderLeft: `4px solid ${formData.brand_color_secondary}`,
            padding: '8px 12px',
            borderRadius: '4px',
            fontSize: '12px'
          }}>
            Message Box
          </div>
        </div>
      </div>
    </div>
  );
};